var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestResultsIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.041 5.77339H22.4705L17.0254 0.328369V4.75781C17.0254 5.31783 17.481 5.77339 18.041 5.77339Z",
    fill: "#5650FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9942 4.75775V0H5.23254C4.11074 0 3.20129 0.909441 3.20129 2.03125V23.9688C3.20129 25.0906 4.11074 26 5.23254 26H20.7676C21.8895 26 22.7989 25.0906 22.7989 23.9688V7.80462H18.0411C16.3611 7.80462 14.9942 6.43779 14.9942 4.75775ZM18.0776 19.1208H8.73518C8.17425 19.1208 7.71956 18.6661 7.71956 18.1051C7.71956 17.5442 8.17425 17.0895 8.73518 17.0895H18.0776C18.6385 17.0895 19.0932 17.5442 19.0932 18.1051C19.0932 18.6661 18.6385 19.1208 18.0776 19.1208ZM19.0932 13.3566C19.0932 13.9176 18.6385 14.3723 18.0776 14.3723H8.73518C8.17425 14.3723 7.71956 13.9176 7.71956 13.3566C7.71956 12.7957 8.17425 12.341 8.73518 12.341H18.0776C18.6385 12.341 19.0932 12.7957 19.0932 13.3566Z",
    fill: "#5650FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestResultsIcon);
export default __webpack_public_path__ + "static/media/TestResultsIcon.4a17e9b794e776a6c9bcee72919bc976.svg";
export { ForwardRef as ReactComponent };